import React from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { ListGroup, ListGroupItem } from "reactstrap"

import { PageContainer } from "../../components"
import { fetchResources } from "../../actions"

// Landing page for reseller users: the customers allocated to them
class ResellerCustomers extends React.Component {
  componentDidMount = () => {
    this.props.fetchResources({ resource: "resellercustomers", force: true })
  }

  render() {
    const { t } = this.props
    const customers =
      this.props.resellercustomers.resellercustomers || []
    return (
      <PageContainer
        title={t("_myCustomers")}
        loading={this.props.resellercustomers.fetching}
      >
        <ListGroup>
          {customers.map((c) => (
            <ListGroupItem
              key={c.customerId}
              tag={Link}
              to={`/reseller/customers/${c.customerId}`}
              action
            >
              {c.companyName}
            </ListGroupItem>
          ))}
        </ListGroup>
      </PageContainer>
    )
  }
}

export default connect((s) => ({ resellercustomers: s.resellercustomers }), {
  fetchResources,
})(withTranslation()(ResellerCustomers))
